export default __webpack_public_path__ + "static/media/childDevelopmnet-blob6.7e3dadbe.svg";